// services/AuthService.js
import Cookies from "js-cookie";

class AuthService {
    static isLogged() {
        const token = Cookies.get("token");
        return !!token;
    }

    static setToken(token) {
        return Cookies.set("token", token);
    }

    static setCustom(name, value) {
        return Cookies.set(name, value);
    }

    static getCustom(name) {
        const val = Cookies.get(name);

        return val;
    }

    static clearAll() {
        Cookies.remove("token");
        Cookies.remove("currency");
        Cookies.remove("user_id");
        Cookies.remove("username");
    }
}

export default AuthService;
